/* eslint-disable mastery/no-dom-manipulation */
/* eslint-disable no-console */
import {
  IS_CONNECT_CARRIER_PROD_DOMAIN,
  IS_CONNECT_CARRIER_UAT_DOMAIN,
} from '@connect-carrier/harness/constants';
import { IS_CYPRESS, IS_LOCAL_DEV } from '@utils/constants';
import { win } from '@utils/win';

export const initConnectCarrierWalkme = (): void => {
  try {
    win.performance.mark('me-walkme-load');

    if (IS_LOCAL_DEV || IS_CYPRESS) {
      return;
    }

    let testInsertion = '';
    if (!IS_CONNECT_CARRIER_UAT_DOMAIN && !IS_CONNECT_CARRIER_PROD_DOMAIN) {
      testInsertion = 'test/';
    }

    const src = `https://cdn.walkme.com/users/d2290e839eb6465ea459f41ee11fe06d/${testInsertion}walkme_d2290e839eb6465ea459f41ee11fe06d_https.js`;

    const walkme = document.createElement('script');
    walkme.type = 'text/javascript';
    walkme.defer = true;
    walkme.src = src;

    const htmlElement = document.getElementsByTagName('html')[0];
    if (htmlElement) {
      htmlElement.appendChild(walkme);
    }

    // Configure WalkMe for Carrier Portal - no user data capture
    win._walkmeConfig = {
      smartLoad: true,
      loadPlatform: 'web',
      walkme_dont_check_browser: '1',
    };
  } catch (err) {
    console.error('Error initializing WalkMe for Carrier Portal:', err);
  }
};
